import avatar from "../../../assets/images/user/avatar-1.jpg";

const emailData = [
  {
    id: 1,
    from: "Maggy Rime",
    email: "johndoe7869@gmail.com",
    thumbnail: avatar,
    welcometext: "Hello Dear...",
    subject: "Here You Have New Opportunity...",
    time: "08:23 AM",
    emailExcerpt:
      "Nam ultrices, libero non mattis pulvinar, nulla pede ullamcorper augue",
    emailContent:
      "<p>Nam ultrices, libero non mattis pulvinar, nulla pede ullamcorper augue, a suscipit nulla elit ac nulla. Sed vel enim sit amet nunc viverra dapibus. Nulla suscipit ligula in lacus.\n\nCurabitur at ipsum ac tellus semper interdum. Mauris ullamcorper purus sit amet nulla. Quisque arcu libero, rutrum ac, lobortis vel, dapibus at, diam. <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. </p>",
    unread: true,
    attachment: false,
    starred: true,
    important: false,
    inbox: true,
    sent: false,
    draft: false,
    spam: false,
    trash: false
  },
  {
    id: 2,
    from: "Nicolas Harget",
    email: "johndoe7869@gmail.com",
    thumbnail: avatar,
    welcometext: "Hello Dear...",
    subject: "Maecenas rhoncus aliquam lacus.",
    time: "6:39 AM",
    emailExcerpt: "Libero non mattis pulvinar, nulla pede ullamcorper augue",
    emailContent:
      "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. </p>Quisque id justo sit amet sapien dignissim vestibulum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Nulla dapibus dolor vel est. Donec odio justo, sollicitudin ut, suscipit a, feugiat et, eros.\n\nVestibulum ac est lacinia nisi venenatis tristique. Fusce congue, diam id ornare imperdiet, sapien urna pretium nisl, ut volutpat sapien arcu sed augue. Aliquam erat volutpat.\n\nIn congue. Etiam justo. Etiam pretium iaculis justo.",
    unread: true,
    attachment: false,
    starred: true,
    important: false,
    inbox: false,
    sent: false,
    draft: true,
    spam: false,
    trash: false
  },
  {
    id: 3,
    from: "Dionysus Samworth",
    email: "johndoe7869@gmail.com",
    thumbnail: avatar,
    welcometext: "Hello Dear...",
    subject: "Mauris viverra diam vitae quam",
    time: "7:01 PM",
    emailExcerpt:
      "Consectetur adipiscing elit, sed do eiusmod tempor incididunt",
    emailContent:
      "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p> <p>Quisque id justo sit amet sapien dignissim vestibulum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Nulla dapibus dolor vel est. Donec odio justo, sollicitudin ut, suscipit a, feugiat et, eros.",
    unread: false,
    attachment: false,
    starred: false,
    important: true,
    inbox: false,
    sent: true,
    draft: false,
    spam: false,
    trash: false,
    label: "Technology"
  },
  {
    id: 4,
    from: "Nathalie Harland",
    email: "johndoe7869@gmail.com",
    thumbnail: avatar,
    welcometext: "Hello Dear...",
    subject: "Nam tristique tortor eu pede.",
    time: "8:43 PM",
    emailExcerpt: "Laboris nisi ut aliquip ex ea commodo consequat",
    emailContent:
      "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. </p><p>Morbi porttitor lorem id ligula. Suspendisse ornare consequat lectus. In est risus, auctor sed, tristique in, tempus sit amet, sem.\n\nFusce consequat. Nulla nisl. Nunc nisl.\n\nDuis bibendum, felis sed interdum venenatis, turpis enim blandit mi, in porttitor pede justo eu massa. Donec dapibus. Duis at velit eu est congue elementum.</p>",
    unread: false,
    attachment: true,
    starred: true,
    important: false,
    inbox: false,
    sent: false,
    draft: true,
    spam: false,
    trash: false
  },
  {
    id: 5,
    from: "Chevalier Joron",
    email: "johndoe7869@gmail.com",
    thumbnail: avatar,
    welcometext: "Hello Dear...",
    subject: "Vestibulum ante ipsum",
    time: "5:55 AM",
    emailExcerpt: "Maecenas ut massa quis augue luctus tincidunt",
    emailContent:
      "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. </p><p>Maecenas ut massa quis augue luctus tincidunt. Nulla mollis molestie lorem. Quisque ut erat.\n\nCurabitur gravida nisi at nibh. In hac habitasse platea dictumst. Aliquam augue quam, sollicitudin vitae, consectetuer eget, rutrum at, lorem.</p>",
    unread: false,
    attachment: false,
    starred: false,
    important: true,
    inbox: true,
    sent: false,
    draft: false,
    spam: false,
    trash: false
  },
  {
    id: 6,
    from: "Robyn Twells",
    email: "johndoe7869@gmail.com",
    thumbnail: avatar,
    welcometext: "Hello Dear...",
    subject: "Ut tellus.",
    time: "10:26 AM",
    emailExcerpt: "Cum sociis natoque penatibus et magnis dis parturient",
    emailContent:
      "<p>>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\nEtiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.\n\nPraesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.</p>",
    unread: false,
    attachment: true,
    starred: false,
    important: true,
    inbox: true,
    sent: false,
    draft: false,
    spam: false,
    trash: false
  },
  {
    id: 7,
    from: "Averell Brydell",
    email: "johndoe7869@gmail.com",
    thumbnail: avatar,
    welcometext: "Hello Dear...",
    subject: "In hac habitasse platea dictumst.",
    time: "12:55 PM",
    emailExcerpt: "Vestibulum rutrum rutrum neque magnis",
    emailContent:
      "<p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\nEtiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.\n\nPraesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.</p>",
    unread: true,
    attachment: true,
    starred: false,
    important: false,
    inbox: true,
    sent: false,
    draft: false,
    spam: false,
    trash: false
  },
  {
    id: 8,
    from: "Nannie Ineson",
    email: "johndoe7869@gmail.com",
    thumbnail: avatar,
    welcometext: "Hello Dear...",
    subject: "Sed sagittis.",
    time: "1:05 AM",
    emailExcerpt: "Natoque rutrum rutrum neque magnis",
    emailContent:
      "<p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\nEtiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.\n\nPraesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.</p>",
    unread: false,
    attachment: true,
    starred: false,
    important: true,
    inbox: false,
    sent: false,
    draft: false,
    spam: true,
    trash: false
  },
  {
    id: 9,
    from: "Hedvige Keble",
    email: "johndoe7869@gmail.com",
    thumbnail: avatar,
    welcometext: "Hello Dear...",
    subject: "Duis bibendum.",
    time: "1:44 PM",
    emailExcerpt: "Praesent id massa id nisl venenatis lacinia",
    emailContent:
      "<p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\nEtiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.\n\nPraesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.</p>",
    unread: false,
    attachment: true,
    starred: false,
    important: false,
    inbox: false,
    sent: false,
    draft: false,
    spam: false,
    trash: true
  },
  {
    id: 10,
    from: "Othilia Briston",
    email: "johndoe7869@gmail.com",
    thumbnail: avatar,
    welcometext: "Hello Dear...",
    subject: "Proin interdum mauris non ligula pellentesque ultrices.",
    time: "7:37 AM",
    emailExcerpt: "Vestibulum rutrum rutrum neque magnis",
    emailContent:
      "<p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\nEtiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.\n\nPraesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.</p>",
    unread: false,
    attachment: true,
    starred: true,
    important: false,
    inbox: false,
    sent: true,
    draft: false,
    spam: false,
    trash: false
  },
  {
    id: 11,
    from: "Michel Foulgham",
    email: "johndoe7869@gmail.com",
    thumbnail: avatar,
    welcometext: "Hello Dear...",
    subject: "Nulla mollis molestie lorem.",
    time: "10:44 AM",
    emailExcerpt: "Cras id massa id nisl venenatis lacinia",
    emailContent:
      "<p>Nullam sit amet turpis elementum ligula vehicula consequat. Morbi a ipsum. Integer a nibh.\n\nIn quis justo. Maecenas rhoncus aliquam lacus. Morbi quis tortor id nulla ultrices aliquet.\n\nMaecenas leo odio, condimentum id, luctus nec, molestie sed, justo. Pellentesque viverra pede ac diam. Cras pellentesque volutpat dui.</p>",
    unread: false,
    attachment: false,
    starred: true,
    important: false,
    inbox: true,
    sent: false,
    draft: false,
    spam: false,
    trash: false
  },
  {
    id: 12,
    from: "Elsie Carlucci",
    email: "johndoe7869@gmail.com",
    thumbnail: avatar,
    welcometext: "Hello Dear...",
    subject: "Aenean lectus.",
    time: "12:01 PM",
    emailExcerpt: "Suspendisse potenti. In eleifend quam a odio",
    emailContent:
      "<p>Suspendisse potenti. In eleifend quam a odio. In hac habitasse platea dictumst.\n\nMaecenas ut massa quis augue luctus tincidunt. Nulla mollis molestie lorem. Quisque ut erat.\n\nCurabitur gravida nisi at nibh. In hac habitasse platea dictumst. Aliquam augue quam, sollicitudin vitae, consectetuer eget, rutrum at, lorem.</p>",
    unread: false,
    attachment: false,
    starred: false,
    important: false,
    inbox: true,
    sent: false,
    draft: true,
    spam: false,
    trash: true
  },
  {
    id: 13,
    from: "Forest Hehir",
    email: "johndoe7869@gmail.com",
    thumbnail: avatar,
    welcometext: "Hello Dear...",
    subject: "Morbi a ipsum.",
    time: "2:58 PM",
    emailExcerpt: "Morbi vel lectus in quam fringilla rhoncus",
    emailContent:
      "<p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Proin risus. Praesent lectus.\n\nVestibulum quam sapien, varius ut, blandit non, interdum in, ante. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Duis faucibus accumsan odio. Curabitur convallis.\n\nDuis consequat dui nec nisi volutpat eleifend. Donec ut dolor. Morbi vel lectus in quam fringilla rhoncus.</p>",
    unread: false,
    attachment: true,
    starred: true,
    important: true,
    inbox: false,
    sent: true,
    draft: false,
    spam: false,
    trash: false
  },
  {
    id: 14,
    from: "Pauli Boase",
    email: "johndoe7869@gmail.com",
    thumbnail: avatar,
    welcometext: "Hello Dear...",
    subject: "Aliquam erat volutpat.",
    time: "7:47 AM",
    emailExcerpt: "Lorem vel lectus in quam fringilla rhoncus",
    emailContent:
      "<p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Proin risus. Praesent lectus.\n\nVestibulum quam sapien, varius ut, blandit non, interdum in, ante. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Duis faucibus accumsan odio. Curabitur convallis.\n\nDuis consequat dui nec nisi volutpat eleifend. Donec ut dolor. Morbi vel lectus in quam fringilla rhoncus.</p>",
    unread: false,
    attachment: false,
    starred: true,
    important: false,
    inbox: false,
    sent: false,
    draft: false,
    spam: false,
    trash: true
  },
  {
    id: 15,
    from: "Francene Shermore",
    email: "johndoe7869@gmail.com",
    thumbnail: avatar,
    welcometext: "Hello Dear...",
    subject: "Nunc rhoncus dui vel sem.",
    time: "4:42 PM",
    emailExcerpt: "Suspendisse potenti. In eleifend quam a odio",
    emailContent:
      "<p>Suspendisse potenti. In eleifend quam a odio. In hac habitasse platea dictumst.\n\nMaecenas ut massa quis augue luctus tincidunt. Nulla mollis molestie lorem. Quisque ut erat.\n\nCurabitur gravida nisi at nibh. In hac habitasse platea dictumst. Aliquam augue quam, sollicitudin vitae, consectetuer eget, rutrum at, lorem.</p>",
    unread: false,
    attachment: true,
    starred: false,
    important: false,
    inbox: false,
    sent: false,
    draft: false,
    spam: false,
    trash: true
  },
  {
    id: 16,
    from: "Elbert Krauss",
    email: "johndoe7869@gmail.com",
    thumbnail: avatar,
    welcometext: "Hello Dear...",
    subject: "Nulla tempus.",
    time: "11:54 PM",
    emailExcerpt: "Vestibulum rutrum rutrum neque magnis",
    emailContent:
      "<p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\nEtiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.\n\nPraesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.</p>",
    unread: true,
    attachment: false,
    starred: false,
    important: true,
    inbox: true,
    sent: false,
    draft: false,
    spam: false,
    trash: true
  },
  {
    id: 17,
    from: "Bale Hickisson",
    email: "johndoe7869@gmail.com",
    thumbnail: avatar,
    welcometext: "Hello Dear...",
    subject: "Quisque id justo sit amet sapien dignissim vestibulum.",
    time: "12:25 PM",
    emailExcerpt: "Natoque rutrum rutrum neque magnis",
    emailContent:
      "<p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\nEtiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.\n\nPraesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.</p>",
    unread: true,
    attachment: false,
    starred: false,
    important: false,
    inbox: false,
    sent: false,
    draft: false,
    spam: true,
    trash: false
  },
  {
    id: 18,
    from: "Diandra Leppo",
    email: "johndoe7869@gmail.com",
    thumbnail: avatar,
    welcometext: "Hello Dear...",
    subject: "Curabitur at ipsum ac tellus semper interdum.",
    time: "7:02 AM",
    emailExcerpt: "Natoque rutrum rutrum neque magnis",
    emailContent:
      "<p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\nEtiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.\n\nPraesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.</p>",
    unread: false,
    attachment: false,
    starred: false,
    important: true,
    inbox: false,
    sent: true,
    draft: false,
    spam: false,
    trash: false
  },
  {
    id: 19,
    from: "Wynn Beden",
    email: "johndoe7869@gmail.com",
    thumbnail: avatar,
    welcometext: "Hello Dear...",
    subject: "Morbi porttitor lorem id ligula.",
    time: "8:38 PM",
    emailExcerpt: "Cum rutrum rutrum neque magnis",
    emailContent:
      "<p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\nEtiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.\n\nPraesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.</p>",
    unread: true,
    attachment: false,
    starred: false,
    important: false,
    inbox: false,
    sent: false,
    draft: true,
    spam: false,
    trash: false
  },
  {
    id: 20,
    from: "Jean Abbitt",
    email: "johndoe7869@gmail.com",
    thumbnail: avatar,
    welcometext: "Hello Dear...",
    subject: "Donec posuere metus vitae ipsum.",
    time: "7:10 PM",
    emailExcerpt: "Aenean rutrum rutrum neque magnis",
    emailContent:
      "<p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\nEtiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.\n\nPraesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.</p>",
    unread: false,
    attachment: true,
    starred: true,
    important: true,
    inbox: true,
    sent: false,
    draft: false,
    spam: false,
    trash: false
  }
];

export default emailData;
